import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'era-title-h4',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './title-h4.component.html',
})
export class TitleH4Component {
  readonly isDetail = input(false);
}
